import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { postSolicitudClase } from '../lib/api';
import { st } from '../lib/solicitudesTxt';

export default function SolicitarClase() {
  const { i18n } = useTranslation();
  const lang = (i18n.resolvedLanguage || 'es').toLowerCase();
  const T = (k) => st(lang, k);
  const [f, setF] = useState({ nombre: '', email: '', telefono: '', modalidad: 'online', num_personas: 1, fecha_deseada: '', hora_deseada: '', mensaje: '' });
  const [estado, setEstado] = useState('idle');
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));
  const hoy = new Date().toISOString().slice(0, 10);

  async function enviar(e) {
    e.preventDefault();
    setEstado('enviando');
    try { await postSolicitudClase({ ...f, num_personas: Number(f.num_personas), idioma: lang }); setEstado('ok'); }
    catch { setEstado('error'); }
  }

  if (estado === 'ok') {
    return (
      <main className="horarios-page"><header className="horarios-head">
        <h1 className="horarios-titulo">{T('ok_t')}</h1><p className="horarios-sub">{T('ok_p')}</p>
      </header></main>
    );
  }
  return (
    <main className="horarios-page">
      <header className="horarios-head">
        <h1 className="horarios-titulo">{T('titulo')}</h1>
        <p className="horarios-sub">{T('sub')}</p>
      </header>
      <form className="solic-form" onSubmit={enviar}>
        <div className="solic-campo"><label>{T('nombre')}</label><input required value={f.nombre} onChange={set('nombre')} maxLength={100} autoComplete="name" /></div>
        <div className="solic-fila">
          <div className="solic-campo"><label>{T('email')}</label><input required type="email" value={f.email} onChange={set('email')} maxLength={160} autoComplete="email" /></div>
          <div className="solic-campo"><label>{T('telefono')}</label><input type="tel" value={f.telefono} onChange={set('telefono')} maxLength={30} autoComplete="tel" /></div>
        </div>
        <div className="solic-fila">
          <div className="solic-campo"><label>{T('modalidad')}</label>
            <select value={f.modalidad} onChange={set('modalidad')}>
              <option value="online">{T('online')}</option><option value="presencial">{T('presencial')}</option>
            </select>
          </div>
          <div className="solic-campo"><label>{T('personas')}</label><input type="number" min="1" max="20" value={f.num_personas} onChange={set('num_personas')} /></div>
        </div>
        <div className="solic-fila">
          <div className="solic-campo"><label>{T('fecha')}</label><input required type="date" min={hoy} value={f.fecha_deseada} onChange={set('fecha_deseada')} /></div>
          <div className="solic-campo"><label>{T('hora')}</label><input required type="time" value={f.hora_deseada} onChange={set('hora_deseada')} /></div>
        </div>
        <div className="solic-campo"><label>{T('mensaje')}</label><textarea rows={4} value={f.mensaje} onChange={set('mensaje')} maxLength={500} /></div>
        {estado === 'error' && <p className="modal-error-general">{T('error')}</p>}
        <button type="submit" className="solic-btn" disabled={estado === 'enviando'}>{estado === 'enviando' ? T('enviando') : T('enviar')}</button>
      </form>
    </main>
  );
}
